// extracted by mini-css-extract-plugin
export default {"icon":"TaskTemplatesList_icon__4XMGr"};